import React, { useContext } from 'react';
import { Gallery, Item } from 'react-photoswipe-gallery';
import { Link } from 'react-router-dom';
import GalleryContext from '../../Context/Gallery';

const GalleryImages = () => {
  const { smallImages } = useContext(GalleryContext);
  return (
    <Gallery>
      {smallImages &&
        smallImages.map((item, i) => {
          return (
            <figure className='col-xl-3 col-md-4 col-sm-6 box-col-33' key={i}>
              <Item original={require(`../../assets/images/${item}`)} width='1024' height='768'>
                {({ ref, open }) => (
                  <Link onClick={open}>
                    <img className='img-thumbnail' ref={ref} src={require(`../../assets/images/${item}`)} alt='' />
                  </Link>
                )}
              </Item>
            </figure>
          );
        })}
    </Gallery>
  );
};
export default GalleryImages;
